import { type ComponentProps } from "react";

import { cn } from "@/lib/utils";

const Paper = ({ className, ref, ...props }: ComponentProps<"div">) => (
  <div
    ref={ref}
    className={cn("rounded-sm border-0 bg-card shadow-none", className)}
    {...props}
  />
);
Paper.displayName = "Paper";

export { Paper };
